// frontend/app/screens/ForceUpgradeScreen/storeLinks.ts
import {Platform} from 'react-native';
import DeviceInfo from 'react-native-device-info';

import config from '../../config';

/**
 * Get Play Store package ID from DeviceInfo
 * On Android, getBundleId() returns the package name (e.g., au.com.lmg.bottlemart)
 * which is exactly what Play Store uses for app identification
 */
const getPlayStorePackage = (): string => {
  return DeviceInfo.getBundleId();
};

/**
 * Get platform-native deep link for direct store navigation
 * - iOS: itms-apps:// scheme opens App Store directly (no Safari redirect)
 * - Android: market:// scheme opens Play Store directly (uses bundle ID from DeviceInfo)
 *
 * @returns Deep link URL or null for unsupported platforms/missing config
 */
export const getStoreDeepLink = (): string | null => {
  if (Platform.OS === 'ios') {
    const appStoreId = config.APP_STORE_ID;
    if (!appStoreId) return null;
    return `itms-apps://apps.apple.com/app/id${appStoreId}`;
  }

  if (Platform.OS === 'android') {
    const packageId = getPlayStorePackage();
    return `market://details?id=${packageId}`;
  }

  return null;
};

/**
 * Get HTTPS fallback URL for store navigation
 * Used when deep link fails (e.g., store app not installed)
 *
 * @returns HTTPS URL or null for unsupported platforms/missing config
 */
export const getStoreFallbackUrl = (): string | null => {
  if (Platform.OS === 'ios') {
    const appStoreId = config.APP_STORE_ID;
    if (!appStoreId) return null;
    return `https://apps.apple.com/au/app/id${appStoreId}`;
  }

  if (Platform.OS === 'android') {
    const packageId = getPlayStorePackage();
    return `https://play.google.com/store/apps/details?id=${packageId}`;
  }

  return null;
};
